import { ReactElement } from 'react';
import { Box, Button, TableCell, TableRow } from '@mui/material';
import { Styles } from 'common/types/styles';
import { PDPAttributeHistoryV2Item } from 'common/services/api/content/content-api.types';
import { formatMoney } from 'common/utils/numbers';
import { format } from 'date-fns';
import toast from 'react-hot-toast';
import { TruncateContainer } from 'common/ui/containers/truncate-container';

const styles: Styles = {
  cellContainer: { display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', width: 250 },
  copyBtn: { alignSelf: 'flex-end' },
};

interface Props {
  h: PDPAttributeHistoryV2Item;
}

export function PdpHistoryItemV2({ h }: Props): ReactElement {
  const getCellValue = (value: unknown) => {
    switch (typeof value) {
      case 'object': {
        return JSON.stringify(value ?? '');
      }
      default:
        return String(value ?? '');
    }
  };

  return (
    <TableRow>
      <TableCell>{h.generated_at ? format(new Date(h.generated_at), 'dd/MM/yyyy hh:mm:ss') : '-'}</TableCell>
      <TableCell>{h.attribute_key}</TableCell>
      <TableCell>{h.category}</TableCell>
      <TableCell>{h.model}</TableCell>
      <TableCell>{h.cost ? formatMoney(h.cost, { minimumFractionDigits: 6 }) : '-'}</TableCell>
      <TableCell>{h.process}</TableCell>
      <TableCell>{h.generation_type}</TableCell>
      <TableCell>
        <Box sx={styles.cellContainer}>
          {h.value && (
            <Button
              onClick={() => {
                navigator.clipboard.writeText(getCellValue(h.value));
                toast.success('Message copied!');
              }}
              sx={styles.copyBtn}
              size="small"
            >
              Copy
            </Button>
          )}
          <TruncateContainer maxHeight={70}>{getCellValue(h.value)}</TruncateContainer>
        </Box>
      </TableCell>
    </TableRow>
  );
}
